
(function () {

  const root = document.querySelector('[data-product-form]');
  if (!root) return;

  let variants = [];
  const dataEl = document.querySelector('[data-product-variants]');
  if (dataEl) {
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  }

  const selected = [];   /* option values, index = option position - 1 */

  function str(key, fallback, vars) {
    return window.t ? window.t(key, fallback, vars) : fallback;
  }

  function money(cents) {
    return window.TwoLaneCart
      ? window.TwoLaneCart.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    return variants.find(v =>
      v.options.every((opt, i) => selected[i] === undefined || selected[i] === opt)
    );
  }

  function isValueAvailable(optionIndex, value) {
    return variants.some(v => {
      if (v.options[optionIndex] !== value) return false;
      if (!v.available) return false;
      return v.options.every((opt, i) =>
        i === optionIndex || selected[i] === undefined || selected[i] === opt
      );
    });
  }

  const stage    = document.querySelector('.product-gallery__stage');
  const mainImg  = document.querySelector('.product-gallery__main');
  const thumbs   = Array.from(document.querySelectorAll('.product-gallery__thumb'));

  function currentImageSrc() {
    if (!mainImg) return '';
    return mainImg.getAttribute('data-current') || mainImg.src || '';
  }

  function showImage(src, thumbEl) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
    mainImg.setAttribute('data-current', src);
    thumbs.forEach(t => t.classList.toggle('is-active', t === thumbEl));
    if (stage) stage.classList.remove('is-zoomed');
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      showImage(thumb.dataset.full || thumb.querySelector('img').src, thumb);
    });
  });

  if (stage) {
    stage.addEventListener('click', function () {
      stage.classList.toggle('is-zoomed');
    });

    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      const rect = stage.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
    });

    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zoomed');
    });
  }

  const optionGroups = Array.from(root.querySelectorAll('[data-option-index]'));

  let booted = false;

  function updateUrl(variantId) {
    if (!booted) return;
    if (!window.history || !window.history.replaceState) return;
    const url = new URL(window.location.href);
    if (String(url.searchParams.get('variant')) === String(variantId)) return;
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  function variantFromUrl() {
    const id = new URLSearchParams(window.location.search).get('variant');
    if (!id) return null;
    return variants.find(function (v) { return String(v.id) === String(id); }) || null;
  }

  function valueExists(optionIndex, value) {
    return variants.some(v => {
      if (v.options[optionIndex] !== value) return false;
      return v.options.every((opt, i) =>
        i === optionIndex || selected[i] === undefined || selected[i] === opt
      );
    });
  }

  function syncAvailability() {
    const soldOut     = str('sold_out', 'Sold Out');
    const unavailable = str('unavailable', 'Unavailable');
    optionGroups.forEach(group => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll('[data-option-value]').forEach(btn => {
        const value = btn.dataset.optionValue;
        const ok = isValueAvailable(index, value);
        btn.classList.toggle('is-unavailable', !ok);
        btn.removeAttribute('aria-disabled');
        btn.setAttribute('aria-label', ok
          ? value
          : value + ' — ' + (valueExists(index, value) ? soldOut : unavailable));
      });
    });
  }

  function syncVariant() {
    const variant = findVariant();
    const addBtn  = root.querySelector('[data-add-to-cart]');
    const priceEl = root.querySelector('[data-price-current]');
    const compEl  = root.querySelector('[data-price-compare]');
    const saveEl  = root.querySelector('[data-price-save]');
    const skuEl   = root.querySelector('[data-variant-sku]');
    const stockEl = root.querySelector('[data-variant-stock]');

    const wallets   = root.querySelector('.product-buy__wallets');
    const bis       = document.querySelector('[data-back-in-stock]');
    const stickyAdd = document.querySelector('[data-sticky-add]');

    if (!variant) {
      const unavailable = str('unavailable', 'Unavailable');
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = unavailable; }
      if (stockEl) {
        stockEl.textContent = unavailable;
        stockEl.hidden = false;
        stockEl.classList.remove('product-stock--low');
        stockEl.classList.add('product-stock--out');
      }
      if (wallets) wallets.hidden = true;
      if (bis) bis.hidden = true;
      if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = unavailable; }
      syncAvailability();
      return;
    }

    if (wallets) wallets.hidden = false;

    if (priceEl) priceEl.textContent = money(variant.price);

    if (compEl) {
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compEl.hidden = !hasCompare;
      if (hasCompare) compEl.textContent = money(variant.compare_at_price);
      if (saveEl) {
        saveEl.hidden = !hasCompare;
        if (hasCompare) {
          const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = str('save', 'Save ' + pct + '%', { PCT: pct });
        }
      }
    }

    if (skuEl)   skuEl.textContent = str('sku', 'SKU') + ': ' + (variant.sku || '—');
    if (stockEl) {
      const tracked = variant.inventory_management !== null &&
                      variant.inventory_management !== undefined &&
                      variant.inventory_management !== '';
      const qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
      const low = variant.available && tracked && qty !== null && qty > 0 && qty < 5;

      const backorder = variant.available && tracked &&
                        variant.inventory_policy === 'continue' &&
                        qty !== null && qty <= 0;

      let stockText;
      if (!variant.available) stockText = str('sold_out', 'Sold Out');
      else if (backorder)     stockText = '';
      else if (low)           stockText = str('low_stock', 'Only ' + qty + ' left in stock', { COUNT: qty });
      else                    stockText = str('in_stock', 'In stock');
      stockEl.textContent = stockText;
      stockEl.hidden = backorder;

      stockEl.classList.toggle('product-stock--low', low);
      stockEl.classList.toggle('product-stock--out', !variant.available);
    }

    const deepLinked = !booted && variantFromUrl();
    if ((booted || deepLinked) && variant.featured_image && mainImg &&
        variant.featured_image !== currentImageSrc()) {
      const match = thumbs.find(t => (t.dataset.full || '') === variant.featured_image);
      showImage(variant.featured_image, match || null);
    }

    const variantInput = root.querySelector('[data-variant-input]');
    if (variantInput && String(variantInput.value) !== String(variant.id)) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateUrl(variant.id);

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? str('add_to_cart', 'Add to Cart')
        : str('sold_out', 'Sold Out');
      addBtn.dataset.variantId    = variant.id;
      addBtn.dataset.price        = variant.price;
      addBtn.dataset.comparePrice = variant.compare_at_price || 0;
      addBtn.dataset.variantTitle = variant.title === 'Default Title' ? '' : variant.title;
      addBtn.dataset.image        = variant.featured_image || (mainImg ? mainImg.src : '');
    }

    if (bis) {
      bis.hidden = variant.available;
      const vTitle = bis.querySelector('[data-bis-variant]');
      const vSku   = bis.querySelector('[data-bis-sku]');
      const vBody  = bis.querySelector('[data-bis-body]');
      const label  = variant.title === 'Default Title' ? '' : variant.title;
      if (vTitle) vTitle.value = label;
      if (vSku)   vSku.value   = variant.sku || '';
      if (vBody)  vBody.value  =
        'Restock request — ' + document.title.split('–')[0].trim() +
        (label ? ' / ' + label : '') +
        (variant.sku ? ' (SKU ' + variant.sku + ')' : '');
    }

    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = money(variant.price);

    if (stickyAdd) {
      stickyAdd.disabled = !variant.available;
      stickyAdd.textContent = variant.available
        ? str('add_to_cart', 'Add to Cart')
        : str('sold_out', 'Sold Out');
    }

    syncAvailability();
  }

  optionGroups.forEach(group => {
    const index = Number(group.dataset.optionIndex);

    const urlVariant = variantFromUrl();
    if (urlVariant && urlVariant.options[index] !== undefined) {
      selected[index] = urlVariant.options[index];
      group.querySelectorAll('[data-option-value]').forEach(function (b) {
        const match = b.dataset.optionValue === urlVariant.options[index];
        b.classList.toggle('is-selected', match);
        if (match) {
          const lbl = group.querySelector('[data-option-selected]');
          if (lbl) lbl.textContent = b.dataset.optionValue;
        }
      });
    } else {
      const preset = group.querySelector('[data-option-value].is-selected');
      if (preset) selected[index] = preset.dataset.optionValue;
    }

    group.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-option-value]');
      if (!btn) return;

      group.querySelectorAll('[data-option-value]').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      selected[index] = btn.dataset.optionValue;

      const label = group.querySelector('[data-option-selected]');
      if (label) label.textContent = btn.dataset.optionValue;

      if (btn.dataset.full) showImage(btn.dataset.full, null);

      syncVariant();
    });
  });

  const qtyInput = root.querySelector('[data-product-qty]');

  root.addEventListener('click', function (e) {
    if (!qtyInput) return;
    if (e.target.closest('[data-qty-plus]'))  qtyInput.value = Number(qtyInput.value) + 1;
    if (e.target.closest('[data-qty-minus]')) qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
  });

  const giftToggle = root.querySelector('[data-gift-recipient-toggle]');
  const giftFields = root.querySelector('[data-gift-recipient-fields]');

  if (giftToggle && giftFields) {
    const giftOffset = giftFields.querySelector('[data-gift-recipient-offset]');

    const syncGift = function () {
      const on = giftToggle.checked;
      giftFields.disabled = !on;
      giftFields.hidden = !on;
      giftToggle.setAttribute('aria-expanded', String(on));
      if (giftOffset) giftOffset.value = on ? String(new Date().getTimezoneOffset()) : '';
      if (!on) {
        giftFields.querySelectorAll('input:not([type="hidden"]), textarea').forEach(function (el) {
          el.value = '';
        });
      }
    };

    giftToggle.disabled = false;
    giftToggle.addEventListener('change', syncGift);
    syncGift();
  }

  const buyNow = root.querySelector('[data-buy-now]');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      const addBtn = root.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.click();
    });
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!open));
  });

  const closedOnPhone = document.querySelector('.accordion__trigger[data-closed-on-phone]');
  if (closedOnPhone) {
    if (window.matchMedia('(max-width: 550px)').matches) closedOnPhone.setAttribute('aria-expanded', 'false');
    closedOnPhone.removeAttribute('data-closed-on-phone');
  }

  const stickyBar = document.querySelector('.sticky-buy');
  const buyRow    = root.querySelector('.product-buy');

  if (stickyBar && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' }).observe(buyRow);

    const stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    const mainAdd   = root.querySelector('[data-add-to-cart]');

    stickyBtn?.addEventListener('click', function () {
      root.querySelector('[data-add-to-cart]')?.click();
    });

    if (stickyBtn && mainAdd && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (mainAdd.getAttribute('aria-busy') === 'true') stickyBtn.setAttribute('aria-busy', 'true');
        else stickyBtn.removeAttribute('aria-busy');
      }).observe(mainAdd, { attributes: true, attributeFilter: ['aria-busy'] });
    }
  }

  const fitmentForm = document.querySelector('[data-fitment]');
  if (fitmentForm) {
    const makeSel  = fitmentForm.querySelector('[data-fitment-make]');
    const modelSel = fitmentForm.querySelector('[data-fitment-model]');
    const yearSel  = fitmentForm.querySelector('[data-fitment-year]');
    const yes      = fitmentForm.querySelector('.fitment__result--yes');
    const no       = fitmentForm.querySelector('.fitment__result--no');
    const live     = fitmentForm.querySelector('[data-fitment-live]');

    function announce(el) {
      if (!live || !el) return;
      const span = el.querySelector('span');
      const text = span ? span.textContent : '';
      live.textContent = '';
      requestAnimationFrame(function () { live.textContent = text; });
    }

    let fit = null;
    try {
      const dataEl = fitmentForm.querySelector('[data-fitment-data]');
      fit = dataEl ? JSON.parse(dataEl.textContent) : null;
    } catch (err) { fit = null; }

    const slug = (window.TwoLaneFitment && window.TwoLaneFitment.slug) ||
      function (s) {
        return String(s == null ? '' : s).toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      };

    const PLACEHOLDER = {
      make:  str('fitment_make',  'Make'),
      model: str('fitment_model', 'Model'),
      year:  str('fitment_year',  'Year')
    };

    function fillSel(sel, placeholder, values) {
      sel.innerHTML = '';
      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      sel.appendChild(first);
      values.forEach(function (v) {
        const o = document.createElement('option');
        o.value = v;
        o.textContent = v;
        sel.appendChild(o);
      });
      sel.disabled = values.length === 0;
    }

    function offered(map) {
      const F = window.TwoLaneFitment;
      return F && F.offeredCatalogue ? F.offeredCatalogue(map) : map;
    }

    function catalogue(cb) {
      if (window.TwoLaneVehicleYears) return cb(offered(window.TwoLaneVehicleYears));
      const url = (window.themeAssets && window.themeAssets.vehicles) || '';
      if (!url) return cb(null);
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          const makesMap = offered(data && (data.makes || data));
          if (makesMap) window.TwoLaneVehicleYears = makesMap;
          cb(makesMap);
        })
        .catch(function () { cb(null); });
    }

    catalogue(function (data) {
      if (!data) {
        data = {};
        (fit || []).forEach(function (group) {
          const mk = group[0];
          const years = [];
          String(group[1] || '').split(',').forEach(function (seg) {
            const p2 = seg.split('-');
            const a = Number(p2[0]);
            const b = p2.length > 1 ? Number(p2[1]) : a;
            for (let y = a; y <= b; y++) years.push(String(y));
          });
          data[mk] = data[mk] || {};
          (group[2] || []).forEach(function (md) {
            data[mk][md] = (data[mk][md] || []).concat(years);
          });
        });
      }

      data = offered(data);
      fillSel(makeSel, PLACEHOLDER.make, Object.keys(data).sort());

      makeSel.addEventListener('change', function () {
        const models = data[makeSel.value] ? Object.keys(data[makeSel.value]).sort() : [];
        fillSel(modelSel, PLACEHOLDER.model, models);
        fillSel(yearSel, PLACEHOLDER.year, []);
      });

      modelSel.addEventListener('change', function () {
        const byModel = data[makeSel.value] || {};
        const yrs = (byModel[modelSel.value] || []).slice()
          .sort(function (a, b) { return Number(b) - Number(a); });
        fillSel(yearSel, PLACEHOLDER.year, yrs);
      });

      const makeKeys = Object.keys(data);
      if (makeKeys.length === 1) {
        makeSel.value = makeKeys[0];
        makeSel.dispatchEvent(new Event('change'));
        makeSel.disabled = true;
        makeSel.classList.add('is-fixed');
      }

      try {
        const saved = JSON.parse(localStorage.getItem('2lane:garage') || '{}').active;
        const savedKey = saved && saved.make
          ? Object.keys(data).find(function (k) { return slug(k) === slug(saved.make); })
          : null;
        if (savedKey) {
          if (makeSel.value !== savedKey) {
            makeSel.value = savedKey;
            makeSel.dispatchEvent(new Event('change'));
          }
          const opt = Array.prototype.find.call(modelSel.options, function (o) {
            return slug(o.value) === slug(saved.model);
          });
          if (opt) {
            modelSel.value = opt.value;
            modelSel.dispatchEvent(new Event('change'));
            if (saved.year) yearSel.value = String(saved.year);
          }
        }
      } catch (err) { /* no saved bike */ }
    });

    fitmentForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const year = yearSel.value, model = modelSel.value, make = makeSel.value;
      if (!year || !model || !make) return;

      if (!fit || !fit.length) {
        no.classList.add('is-visible');
        yes.classList.remove('is-visible');
        no.querySelector('span').textContent = str(
          'fit_unknown',
          'Fitment data isn\'t listed for this part — message us with your year and model and we\'ll confirm before you order.'
        );
        announce(no);
        return;
      }

      const fits = window.TwoLaneFitment
        ? window.TwoLaneFitment.verdict(fit, { year: year, make: make, model: model }, null) === 'fits'
        : false;

      yes.classList.toggle('is-visible', fits);
      no.classList.toggle('is-visible', !fits);

      const bike = [year, make, model].filter(Boolean).join(' ');

      yes.querySelector('span').textContent = str(
        'fit_yes_bike',
        str('fit_yes', 'Fits your bike.'),
        { BIKE: bike }
      );

      const listed = window.TwoLaneFitment
        ? window.TwoLaneFitment.summary(fit, null) : '';

      const noFallback = str('fit_no', 'Not confirmed for that bike - contact us and we\'ll find the right part.');
      no.querySelector('span').textContent = listed
        ? str('fit_no_bike_listed', noFallback, { BIKE: bike, LISTED: listed })
        : str('fit_no_bike',        noFallback, { BIKE: bike });

      announce(fits ? yes : no);
    });
  }

  (function relocateFitmentTable() {
    const accordions = document.querySelector('.product-accordions');
    if (!accordions) return;

    const descPanel = accordions.querySelector('.accordion__panel');
    if (!descPanel) return;

    const tables = Array.from(descPanel.querySelectorAll('table'));
    if (!tables.length) return;

    const YEAR_CELL = /^\s*(19|20)\d{2}\s*(?:[-–—]\s*(19|20)?\d{2,4})?\s*$/;

    const fitment = tables.filter(function (t) {
      const rows = Array.from(t.querySelectorAll('tr'));
      if (rows.length < 4) return false;
      const yearish = rows.filter(function (r) {
        const cell = r.querySelector('td, th');
        return cell && YEAR_CELL.test(cell.textContent);
      }).length;
      return yearish / rows.length >= 0.6;
    });
    if (!fitment.length) return;

    const rows = fitment.reduce(function (n, t) {
      return n + Math.max(0, t.querySelectorAll('tr').length - 1);
    }, 0);
    if (!rows) return;

    const wrap = document.createElement('div');
    wrap.className = 'accordion';

    const PANEL_ID = 'product-fitment-list-panel';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'accordion__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', PANEL_ID);

    const label = document.createElement('span');
    label.textContent = str('fitment_list', 'Full fitment list', { COUNT: rows })
      + ' (' + rows + ')';
    trigger.appendChild(label);

    const chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chev.setAttribute('width', '16');
    chev.setAttribute('height', '16');
    chev.setAttribute('viewBox', '0 0 24 24');
    chev.setAttribute('fill', 'none');
    chev.setAttribute('stroke', 'currentColor');
    chev.setAttribute('stroke-width', '2');
    chev.setAttribute('stroke-linecap', 'round');
    chev.setAttribute('stroke-linejoin', 'round');
    chev.setAttribute('aria-hidden', 'true');
    const poly = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    poly.setAttribute('points', '6 9 12 15 18 9');
    chev.appendChild(poly);
    trigger.appendChild(chev);

    const panel = document.createElement('div');
    panel.className = 'accordion__panel product-fitment-list';
    panel.id = PANEL_ID;
    fitment.forEach(function (t) { panel.appendChild(t); });

    wrap.appendChild(trigger);
    wrap.appendChild(panel);
    accordions.appendChild(wrap);
  })();

  (function share() {
    const wrap = document.querySelector('[data-share]');
    if (!wrap) return;
    const nativeBtn = wrap.querySelector('[data-share-native]');
    const fallback  = wrap.querySelector('[data-share-fallback]');
    const status    = wrap.querySelector('[data-share-status]');
    const title = wrap.dataset.title;

    function shareUrl() {
      const base = wrap.dataset.url;
      if (!base) return window.location.href;
      const picked = new URLSearchParams(window.location.search).get('variant');
      if (!picked) return base;
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(picked);
    }

    function flash(msg) {
      status.textContent = msg;
      setTimeout(function () { status.textContent = ''; }, 2200);
    }

    function copy() {
      const done = function () { flash(str('link_copied', 'Link copied')); };
      const url = shareUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          flash(str('share_failed', 'Could not share'));
        });
        return;
      }
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); }
      catch (e) { flash(str('share_failed', 'Could not share')); }
      document.body.removeChild(ta);
    }

    if (navigator.share) {
      nativeBtn.addEventListener('click', function () {
        navigator.share({ title: title, url: shareUrl() }).catch(function () { /* dismissed */ });
      });
    } else {
      fallback.hidden = false;
      nativeBtn.addEventListener('click', copy);
    }

    const copyBtn = wrap.querySelector('[data-share-copy]');
    if (copyBtn) copyBtn.addEventListener('click', copy);
  })();

  syncVariant();
  booted = true;

})();

